"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Avatar = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const lib_1 = require("../../lib");
const utilities_1 = require("../../utilities");
/**
 * Avatar component
 *
 * @visibleName Avatar
 */
const AvatarComponent = ({ children, className, initial = "a", profile, }) => {
    const clsName = (0, lib_1.bem)("avatar", `--${initial.toLowerCase()}`, (0, lib_1.use)(profile, "--profile"));
    return ((0, jsx_runtime_1.jsx)("span", Object.assign({ className: (0, lib_1.classnames)(className, clsName) }, { children: (0, jsx_runtime_1.jsx)("span", { children: initial }, void 0) }), void 0));
};
exports.Avatar = (0, lib_1.compose)((0, utilities_1.Margin)())(AvatarComponent);
//# sourceMappingURL=Avatar.js.map